<template>
    <div class="dashboard-page">
        <!-- 顶部导航组件 -->
        <!-- <Top></Top> -->

        <!-- 主内容区容器 -->
        <div class="recharge-page">
            <!-- 顶部用户信息栏 -->
            <div class="user-info-bar">
                <div class="user-avatar-info">
                    <img src="https://cube.elemecdn.com/3/7c/3ea6beec643485aa6534e16f769jpeg.jpeg" alt="用户头像"
                        class="user-avatar">
                    <div class="user-text">
                        <p class="user-name">桔梗奈落</p>
                        <p class="user-id">账号ID：2198689</p>
                    </div>
                </div>
                <div class="balance-info">
                    <span>余额(云币):</span>
                    <span class="balance">0.00</span>
                </div>
            </div>

            <!-- 充值金额选择区 -->
            <div class="recharge-amount-section">
                <h3 class="section-title">请选择充值金额</h3>
                <div class="amount-selector">
                    <button class="amount-btn" :class="{ active: selectedAmount === 50 }" @click="selectedAmount = 50">¥
                        50</button>
                    <button class="amount-btn" :class="{ active: selectedAmount === 100 }"
                        @click="selectedAmount = 100">¥ 100</button>
                    <button class="amount-btn" :class="{ active: selectedAmount === 300 }"
                        @click="selectedAmount = 300">¥ 300</button>
                    <button class="amount-btn" :class="{ active: selectedAmount === 500 }"
                        @click="selectedAmount = 500">¥ 500</button>
                    <div class="custom-amount">
                        <input type="number" v-model.number="customAmount" placeholder="输入自定义金额" class="custom-input">
                        <button class="confirm-btn" :disabled="!customAmount"
                            @click="selectedAmount = customAmount">确定</button>
                    </div>
                </div>
                <button class="vip-discount-btn">获取大客户折扣</button>
            </div>

            <!-- 充值方式选项卡 -->
            <div class="recharge-method-tabs">
                <button class="tab-btn" :class="{ active: activeTab === 'scan' }" @click="activeTab = 'scan'">
                    <i class="icon-scan"></i> 扫码充值
                </button>
                <button class="tab-btn" :class="{ active: activeTab === 'transfer' }" @click="activeTab = 'transfer'">
                    <i class="icon-transfer"></i> 转账汇款
                </button>
                <button class="tab-btn" :class="{ active: activeTab === 'paypal' }" @click="activeTab = 'paypal'">
                    <i class="icon-paypal"></i> PayPal充值
                </button>
                <button class="tab-btn" :class="{ active: activeTab === 'reward' }" @click="activeTab = 'reward'">
                    <i class="icon-reward"></i> 收益兑换
                </button>
                <button class="tab-btn" :class="{ active: activeTab === 'cooperate' }" @click="activeTab = 'cooperate'">
                    <i class="icon-cooperate"></i> 商务合作
                </button>
            </div>

            <!-- 二维码/内容展示区 -->
            <div class="recharge-content">
                <div class="qr-code-section" v-if="activeTab === 'scan'">
                    <div class="qr-code-area" :class="{ 'empty': !selectedAmount }">
                        <img v-if="selectedAmount" src="https://picsum.photos/seed/qr/200/200" alt="充值二维码"
                            class="qr-code-img">
                        <div v-else class="empty-tip">
                            <i class="icon-wallet"></i>
                            <p>请先在上方确认充值金额</p>
                        </div>
                        <div class="payment-desc" v-if="selectedAmount">
                            <img src="https://picsum.photos/seed/pay/80/20" alt="支付方式" class="payment-icon">
                            <p>请使用支付宝/微信扫码支付</p>
                            <p>支付完成后金额将自动到账</p>
                        </div>
                    </div>
                </div>
                <div class="tab-content" v-else>
                    <el-empty description="该充值方式暂未开放" class="empty-content"></el-empty>
                </div>
            </div>

            <!-- 注意事项 -->
            <div class="notice-section">
                <h4 class="notice-title">注意事项</h4>
                <ul class="notice-list">
                    <li>充值的金额不能提现，亦不能在不同的账号之间转移，仅允许在CG模型网进行消费使用。</li>
                    <li>请务必根据您的自身消费能力和实际需求，合理充值、购买，警惕代充、返利利诱等行为，勿向陌生人付款。</li>
                </ul>
            </div>
        </div>

        <!-- 底部版权组件 -->
        <!-- <Bottom></Bottom> -->
    </div>
</template>

<script>
import Top from '../../../components/Header.vue';
import Bottom from '../../../components/Footer.vue';

export default {
    name: 'RechargePage',
    components: { Top, Bottom },
    data() {
        return {
            selectedAmount: 0, // 选中的充值金额
            customAmount: 0, // 自定义金额
            activeTab: 'scan' // 激活的选项卡
        };
    },
};
</script>

<style lang="less" scoped>
// 深色主题变量
@bg-primary: #121212;
@bg-secondary: #1e1e1e;
@text-primary: #e0e0e0;
@text-secondary: #a0a0a0;
@accent-red: #ef4444;
@border-color: #333;
@hover-color: #2a2a2a;

.recharge-page {
    background-color: @bg-primary;
    color: @text-primary;
    min-height: 100vh;
    padding: 20px 40px;
    box-sizing: border-box;
}

// 用户信息栏
.user-info-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid @border-color;

    .user-avatar-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10%;
            object-fit: cover;
        }

        .user-text {
            .user-name {
                font-size: 16px;
                margin: 0 0 4px 0;
            }

            .user-id {
                font-size: 12px;
                color: @text-secondary;
                margin: 0;
            }
        }
    }

    .balance-info {
        .balance {
            color: @accent-red;
            font-weight: bold;
        }
    }
}

// 充值金额选择区
.recharge-amount-section {
    margin: 30px 0;

    .section-title {
        font-size: 18px;
        margin-bottom: 20px;
    }

    .amount-selector {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 15px;

        .amount-btn {
            background-color: @bg-secondary;
            border: 1px solid @border-color;
            color: @text-primary;
            padding: 12px 24px;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s;

            &.active {
                background-color: @accent-red;
                border-color: @accent-red;
                color: #fff;
            }

            &:hover:not(.active) {
                background-color: @hover-color;
            }
        }

        .custom-amount {
            display: flex;
            gap: 8px;

            .custom-input {
                background-color: @bg-secondary;
                border: 1px solid @border-color;
                color: @text-primary;
                padding: 12px;
                border-radius: 4px;
                width: 120px;
                box-sizing: border-box;

                &::placeholder {
                    color: @text-secondary;
                }
            }

            .confirm-btn {
                background-color: @accent-red;
                border: none;
                color: #fff;
                padding: 0 16px;
                border-radius: 4px;
                cursor: pointer;
                transition: opacity 0.2s;

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }
        }
    }

    .vip-discount-btn {
        background-color: #cba500;
        color: #fff;
        border: none;
        padding: 6px 12px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        float: right;
    }
}

// 充值方式选项卡
.recharge-method-tabs {
    display: flex;
    gap: 1px;
    margin-bottom: 20px;

    .tab-btn {
        background-color: @bg-secondary;
        border: 1px solid @border-color;
        color: @text-secondary;
        padding: 10px 20px;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        gap: 6px;

        .icon-scan,
        .icon-transfer,
        .icon-paypal,
        .icon-reward,
        .icon-cooperate {
            width: 16px;
            height: 16px;
            background-color: @text-secondary;
            border-radius: 2px;
            display: inline-block;
        }

        &.active {
            background-color: @accent-red;
            border-color: @accent-red;
            color: #fff;

            .icon-scan,
            .icon-transfer,
            .icon-paypal,
            .icon-reward,
            .icon-cooperate {
                background-color: #fff;
            }
        }

        &:hover:not(.active) {
            background-color: @hover-color;
            color: @text-primary;
        }
    }
}

// 二维码/内容展示区
.recharge-content {
    background-color: @bg-secondary;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 30px;

    .qr-code-section {
        .qr-code-area {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 240px;

            &.empty {
                opacity: 0.5;
            }

            .qr-code-img {
                width: 200px;
                height: 200px;
                margin-bottom: 15px;
            }

            .empty-tip {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;

                .icon-wallet {
                    width: 32px;
                    height: 32px;
                    background-color: @text-secondary;
                    border-radius: 4px;
                    display: inline-block;
                }

                p {
                    margin: 0;
                    color: @text-secondary;
                }
            }

            .payment-desc {
                text-align: center;

                .payment-icon {
                    height: 20px;
                    margin-bottom: 8px;
                }

                p {
                    margin: 4px 0;
                    font-size: 12px;
                    color: @text-secondary;
                }
            }
        }
    }

    .tab-content {
        .empty-content {
            width: 100%;
            padding: 40px 0;
        }
    }
}

// 注意事项
.notice-section {
    .notice-title {
        font-size: 16px;
        margin-bottom: 10px;
        color: @accent-red;
    }

    .notice-list {
        list-style: none;
        padding: 0;
        font-size: 12px;
        color: @text-secondary;
        line-height: 1.6;

        li {
            margin-bottom: 8px;
        }
    }
}
</style>